import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addModelYear, getSingleModelyear, updateModelYear } from '../../../actions/homeAction'

const ModelYearAdd = () => {
  const [modelYear, setModelYear] = useState({
    modelYear:'',
    modelYearAr:'',
    priority: null,
    active: true
  })
  const [dataEdit, setDataEdit] = useState(false)

const {myUUID} = useParams()

const dispatch = useDispatch()

const location = window.location.href.split('/')[6]

useEffect(() => {
  if(location === 'Update'){
    dispatch(getSingleModelyear(myUUID))
    setDataEdit(true)
  } else {
    setDataEdit(false)
  }
},[])

const singleModelyear = useSelector(state => state.home.singleModelYear)?.response
const data = singleModelyear

useEffect(() => {
  setModelYear({
    modelYear: data?.modelYear,
    modelYearAr: data?.modelYearAr,
    priority: data?.priority,
    active: data?.active === 0 ? 'false' : 'true'
  })
},[data?.modelYear])


console.log("modelYear", myUUID);
  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setModelYear({...modelYear, [name]:value})
  }
  
  const onSave = () => {
    if(dataEdit){
      const payload = {
        modelYear:modelYear.modelYear,
        modelYearAr:modelYear.modelYearAr,
        active: modelYear.active,
        priority: modelYear.priority,
        modelYearId: data.modelYearId
        }
        dispatch(updateModelYear(payload))
      } else {
        dispatch(addModelYear(modelYear))
    }
  }
console.log("datadatadata", singleModelyear);
  return (
    <div className='main-body'>
    <div className='page-wrapper'>
      <div className='page-header'>
        <div className='row align-items-end'>
          <div className='col-lg-8'>
            <div className='page-header-title'>
              <div className='d-inline'>
                <h4>
                  { dataEdit ? `Edit : ${modelYear?.modelYear}` : "Add Model Year" } 
                </h4>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='page-header-breadcrumb'>
              <ul className='breadcrumb-title'>
                <li className='breadcrumb-item'>
                  <Link to='/'>
                    <i className='feather icon-home'></i>{' '}
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link to='/CarDetail/ModelYear'>Model Year</Link>
                </li>
                <li className='breadcrumb-item active'>
                { dataEdit ? "Edit Model Year:" : "Add Model Year" } 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='page-body'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card card-border-default'>
              <div className='card-block'>
                
                <div className='tab-content tabs'>
                  <div
                    className='tab-pane  active'
                    id={'car_user_'}
                    role='tabpanel'
                    aria-labelledby=''>
                      <div className=''>
        	<div className='col-md-6'>
							
						</div>

        {/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Model Year</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='modelYear'
										value={modelYear.modelYear}
										placeholder='Model Year Name'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Model Year Ar</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='modelYearAr'
										value={modelYear.modelYearAr}
										placeholder='Model Year Name Ar'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>

              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={modelYear.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										onChange={onChangeHandle}
										value={modelYear?.status}
                    >
										<option value={true} name='active'>
											Active
										</option>
										<option value={false} name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
							
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> {dataEdit ? 'Update' : 'Add'}
							</button>
							<Link to={'/CarDetail/ModelYear'} className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ModelYearAdd